<template>
    <v-card class="workspace-dashboard__subscription-card" elevation="0" data-home-tour-billing>
        <div class="workspace-dashboard__section-head workspace-dashboard__section-head--compact">
            <div>
                <div class="workspace-dashboard__section-kicker">Subscription</div>
                <h2>{{ displayPlanName }}</h2>
            </div>
            <v-chip size="small" color="primary" variant="tonal">
                {{ summary.plan?.priceLabel || 'Contact sales' }}
            </v-chip>
        </div>

        <div class="workspace-dashboard__subscription-grid">
            <div>
                <span title="Collections owned by this Billing Account.">Dataset Groups</span>
                <strong>{{ datasetGroupCountLabel }}</strong>
            </div>
            <div>
                <span title="Published datasets contained within Dataset Groups.">Datasets</span>
                <strong>{{ datasetCountLabel }}</strong>
            </div>
            <div>
                <span title="Teams owned by this Billing Account and measured against plan limits.">Billing Teams</span>
                <strong>{{ billingTeamUsageLabel }}</strong>
            </div>
            <div>
                <span title="Storage consumed by Dataset Groups owned by this Billing Account.">Storage</span>
                <strong>{{ storageUsageLabel || '0.00 GB' }}</strong>
            </div>
        </div>

        <div class="workspace-dashboard__subscription-actions">
            <v-btn variant="outlined" block :href="summary.links?.billing || '/billing/'">
                Manage Billing
            </v-btn>
        </div>
    </v-card>
</template>

<script>
import {
    formatCount,
    formatStorageAllowance,
    formatStorageFromBytes,
} from 'components/Dashboard/dashboardWorkspace';

export default {
    name: 'DashboardSubscriptionPanel',
    props: {
        summary: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        displayPlanName() {
            if (this.summary.plan?.isEnterprise) {
                return 'Custom Enterprise Plan';
            }

            return this.summary.plan?.name || 'Workspace plan';
        },
        datasetGroupCountLabel() {
            return `${this.summary.workspace?.datasetGroupCount || 0}`;
        },
        datasetCountLabel() {
            return `${this.summary.workspace?.datasetCount || this.summary.usage?.datasets || 0}`;
        },
        billingTeamUsageLabel() {
            const used = this.summary.workspace?.billingTeamCount || this.summary.usage?.billingTeams || this.summary.usage?.seatsUsed || 0;
            const limit = this.summary.usage?.seatsAllowed;

            if (limit === -1) {
                return `${formatCount(used)} / Unlimited`;
            }

            if (limit === null || limit === undefined || limit === '') {
                return `${formatCount(used)} / Custom`;
            }

            return `${formatCount(used)} / ${formatCount(limit)}`;
        },
        storageUsageLabel() {
            return `${formatStorageFromBytes(
                this.summary.usage?.storageUsedBytes
            )} / ${formatStorageAllowance(this.summary.usage?.storageAllowedGb)}`;
        },
    },
};
</script>
